import React from 'react'
import { makeStyles, Theme } from '@material-ui/core/styles'
import AppBar from '@material-ui/core/AppBar'
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import Box from '@material-ui/core/Box'
import { Divider, Typography } from '@material-ui/core'
import FormWrapperDrawer from './FormWrapperDrawer'
import FormWrapperCheckButton from './FormWrapperCheckButton'
import { sanatizeForElementId } from '../../utils/stringUtil'

interface IFormWrapperTabsProps {
  labelId: string
  onChange: (event: unknown, value: number) => void
  selectionFollowsFocus?: boolean
  value: number
  tabs: {
    label: string
    onClick?: (newValue: any) => void
    checked?: boolean
  }[]
  tabMenuLabel?: string
  showTabs?: boolean
  children: React.ReactNode
}

const useStyles = makeStyles((theme: Theme) => ({
  appBar: {
    display: 'flex',
    flexDirection: 'row'
  },
  drawerContainer: {
    display: 'grid',
    placeItems: 'center'
  },
  tabWarningIcon: {
    width: 20,
    height: 20,
    marginLeft: 6,
    color: theme.palette.secondary.main
  }
}))

const FormWrapperTabs = (props: IFormWrapperTabsProps) => {
  const classes = useStyles()
  const {
    labelId,
    onChange,
    selectionFollowsFocus,
    value,
    tabs,
    tabMenuLabel = 'Groupings',
    showTabs = true,
    children
  } = props

  return (
    <>
      {showTabs && (
        <AppBar
          position='sticky'
          color='inherit'
          className={classes.appBar}
          style={{
            zIndex: 100,
            background: '#5567a8',
            color: 'white',
            top: 64
          }}
        >
          <Box className={classes.drawerContainer}>
            <FormWrapperDrawer
              tabs={tabs}
              handleTabChange={onChange}
              menuLabel={tabMenuLabel}
              activeTab={value}
            />
          </Box>
        <Divider orientation='vertical' flexItem />
          <Tabs
            style={{
              width: '100%'
            }}
            aria-labelledby={`${labelId}-${value}`}
            onChange={(event, value) => {
              onChange(event, value)
              const findTab = tabs.find((_tab, index) => value === index)
              if (findTab) {
                findTab.onClick?.(value)
              }
            }}
            selectionFollowsFocus={selectionFollowsFocus}
            value={value}
            variant='scrollable'
            scrollButtons='on'
          >
            {tabs.map((tab) => {
              const label = sanatizeForElementId(tab.label)
              return (
                <Tab
                  key={tab.label}
                  label={
                    <>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: 8
                        }}
                      >
                        <Typography>{tab.label}</Typography>
                        {tab.checked && <FormWrapperCheckButton />}
                      </div>
                    </>
                  }
                  aria-controls={`${label}-tabpanel`}
                  id={`${label}-tab`}
                  data-testid={`${label}-tab`}
                />
              )
            })}
          </Tabs>
        </AppBar>
      )}

      {children}
    </>
  )
}

export default FormWrapperTabs
